import React, { Fragment, useState } from 'react';
import { faFacebookMessenger, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone, faPlus, faSms, faTicketAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row, Tooltip } from 'reactstrap';

const ConnectButton = ({ disabled, name, inetrgationName, iconName, handleEvent }) => {

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);

    const handleClick = () => {
        console.log(disabled, !disabled);
        if (!disabled) {
            handleEvent();
        }
    }

    return (
        <Fragment>
            {inetrgationName &&
                <Row className="mb-2">
                    <Button onClick={() => handleClick()} color="primary" className='btn-round' id={inetrgationName} size="xs">
                        <FontAwesomeIcon icon={iconName}></FontAwesomeIcon> {name}
                    </Button>
                    {disabled &&
                        <Tooltip
                            autoHide={true}
                            flip={true}
                            placement="right"
                            isOpen={tooltipOpen}
                            target={inetrgationName}
                            toggle={toggle}
                        >
                            {name} is not connected.
                        </Tooltip>}
                </Row>}

        </Fragment >
    );
}

export default ConnectButton;